import angular from 'angular';
import brokerAllocationTool from './brokerAllocationTool';
import './style.scss';

export default angular
  .module('components.brokerAllocationTool', [])
  .component('brokerAllocationTool', brokerAllocationTool).name;
